import React, { useState } from 'react';
import Layout from '../../components/Layout';
import axios from 'axios';
import swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { Select, TimePicker } from "antd";
import dayjs from "dayjs";

const CreateZoomMeeting = () => {

    const [formData, setFormData] = useState({
        topic: "",
        start_date: "",
        start_time: "",
        duration: "",
        recurrence_type: "",
        weekly_days: [],
        end_date: "",
        alternative_hosts: ""
    });

    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleWeekDaysChange = (values) => {
        setFormData(prev => ({
            ...prev,
            weekly_days: values.map(Number)
        }));
    };

    const handleTimeChange = (time) => {
        setFormData(prev => ({
            ...prev,
            start_time: time ? dayjs(time).format("hh:mm A") : ""
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            ...formData,
            recurrence_type: Number(formData.recurrence_type),
            duration: Number(formData.duration)
        };

        try {
            await axios.post("/api/v1/adm/zoom/store-recurring", payload);

            swal.fire("Success!", "Zoom meeting created successfully.", "success");
            navigate("/zoom-meetings");

        } catch (error) {
            console.error(error);
            swal.fire("Error!", "Something went wrong.", "error");
        }
    };

    const options = [
        { label: "Sunday", value: 1 },
        { label: "Monday", value: 2 },
        { label: "Tuesday", value: 3 },
        { label: "Wednesday", value: 4 },
        { label: "Thursday", value: 5 },
        { label: "Friday", value: 6 },
        { label: "Saturday", value: 7 }
    ];

    const handleGoBack = () => {
        window.history.back()
    };

    return (
        <Layout>
            <div className='page-content'>
                <div className="container">
                    <div className="card p-5">
                        <div className='d-flex'>
                            <div className='col-md-6 col-lg-6 text-start'><h5>Create Meeting</h5></div>
                            <div className='col-md-6 col-lg-6 text-end'><button className='btn btn-primary' onClick={handleGoBack}> Back</button></div>
                        </div>
                        <span id="student_message" />
                        <br />
                        <form onSubmit={handleSubmit}>
                            <div className="row g-4">

                                <div className="col-md-6">
                                    <label className="form-label">Topic *</label>
                                    <input
                                        type="text"
                                        placeholder='Enter topic'
                                        name="topic"
                                        className="form-control"
                                        value={formData.topic}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">Start Date *</label>
                                    <input
                                        type="date"
                                        name="start_date"
                                        className="form-control"
                                        min={dayjs().format("YYYY-MM-DD")}
                                        value={formData.start_date}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">Start Time *</label>
                                    <TimePicker
                                        use12Hours
                                        format="hh:mm A"
                                        className="w-100"
                                        onChange={handleTimeChange}
                                        disabledTime={() => {
                                            if (formData.start_date !== dayjs().format("YYYY-MM-DD")) return {};

                                            const now = dayjs();

                                            return {
                                                disabledHours: () =>
                                                    Array.from({ length: now.hour() }, (_, i) => i),
                                                disabledMinutes: (selectedHour) =>
                                                    selectedHour === now.hour()
                                                        ? Array.from({ length: now.minute() }, (_, i) => i)
                                                        : [],
                                            };
                                        }}
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">Duration (minutes) *</label>
                                    <input
                                        type="number"
                                        name="duration"
                                        placeholder='Enter Duration'
                                        className="form-control"
                                        value={formData.duration}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">Recurrence Type *</label>
                                    <select
                                        name="recurrence_type"
                                        className="form-select"
                                        value={formData.recurrence_type}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select</option>
                                        <option value={1}>Daily</option>
                                        <option value={2}>Weekly</option>
                                    </select>
                                </div>

                                {formData.recurrence_type == 2 && (
                                    <div className="col-md-6">
                                        <label className="form-label">Week Days *</label>
                                        <Select
                                            mode="multiple"
                                            options={options}
                                            onChange={handleWeekDaysChange}
                                            style={{ width: "100%" }}
                                            placeholder="Select week days"
                                            className='zoom-multi-select'
                                        />
                                    </div>
                                )}

                                <div className="col-md-6">
                                    <label className="form-label">End Date *</label>
                                    <input
                                        type="date"
                                        name="end_date"
                                        className="form-control"
                                        min={
                                            formData.start_date
                                                ? dayjs(formData.start_date).add(7, "day").format("YYYY-MM-DD")
                                                : ""
                                        }
                                        value={formData.end_date}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">Alternative Hosts</label>
                                    <input
                                        type="email"
                                        name="alternative_hosts"
                                        placeholder='Comma-Separated List of Emails'
                                        className="form-control"
                                        value={formData.alternative_hosts}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="col-md-12 mt-4">
                                    <button type="submit" className="btn btn-primary">
                                        Submit
                                    </button>
                                </div>

                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default CreateZoomMeeting;
